import React from 'react';

interface CheckboxOverlayProps {
  isChecked: boolean;
  onToggle: (e: React.MouseEvent) => void;
  position?: 'left' | 'right';
  layout?: 'list' | 'grid';
  size?: 'small' | 'medium' | 'large';
  isInBindle?: boolean; // Show circle inside checkbox to indicate item is in the active bindle
}

export const CheckboxOverlay: React.FC<CheckboxOverlayProps> = ({
  isChecked,
  onToggle,
  position = 'left',
  layout = 'list',
  size = 'medium',
  isInBindle = false,
}) => {
  // Smaller checkbox for small list view
  const checkboxSize = size === 'small' ? 24 : 28;
  const checkmarkSize = size === 'small' ? 14 : 16;
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onToggle(e);
  };
  
  // iOS 26 liquid glass style for all views
  const isLiquidGlass = true;
  
  return (
    <div
      className="checkbox-overlay"
      onClick={handleClick}
      style={{
        position: 'absolute',
        // Grid: top-right corner; List: top-aligned to avoid overlapping description
        ...(layout === 'grid' 
          ? { top: '12px' } 
          : { top: '16px' }
        ),
        ...(position === 'right' ? { right: '12px' } : { left: '12px' }),
        width: `${checkboxSize}px`,
        height: `${checkboxSize}px`,
        borderRadius: isLiquidGlass ? '8px' : '4px',
        // Liquid glass: frosted translucent background
        // Grid: white border (works on images); List: subtle gray border (works on white bg)
        background: isChecked 
          ? 'var(--color-success)' 
          : 'rgba(142, 142, 147, 0.12)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        border: isChecked 
          ? 'none' 
          : '1.5px solid var(--color-checkbox-border, var(--color-border-strong))',
        boxShadow: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        zIndex: 10,
        transition: 'all 0.2s',
      } as React.CSSProperties}
    >
      {isChecked ? (
        <svg
          width={checkmarkSize}
          height={checkmarkSize}
          viewBox="0 0 24 24"
          fill="none"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      ) : isInBindle ? (
        <div style={{
          width: checkboxSize * 0.45,
          height: checkboxSize * 0.45,
          borderRadius: '50%',
          border: '2px solid var(--color-warning)',
          background: 'transparent',
        }} />
      ) : null}
    </div>
  );
};
